<template>
  <div class="feedback my-8">
    <h2 class="border-0">War das einfach?</h2>

    <div v-if="response != ''" class="max-w-xl mb-4 mt-2 flex items-center bg-green-heinz text-black text-sm font-bold px-4 py-3" role="alert">
      <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
      <p>Vielen Dank für deine Teilnahme!</p>
    </div>

    <form class="w-32 flex" v-if="response == ''">
      <div class="w-1/2">
        <button v-on:click="vote('Y')" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded" type="button">
          Ja!
        </button>
      </div>
      <div class="w-1/2">
        <button v-on:click="vote('N')" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded" type="button">
          Nein!
        </button>
      </div>
    </form>

    <form class="max-w-xl" v-if="response != '' && commentRespone == ''">
      <div class="w-full mb-6 md:mb-0">
        <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-comment">
          Hast du eine Idee zur Verbesserung des Bestellsystems? Immer her damit!
        </label>
        <textarea v-model="comment" class="appearance-none block w-full h-32 text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-comment"></textarea>
      </div>
      <div class="w-full">
        <button v-on:click="sendcomment()" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded" type="button">
          Absenden
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'

export default {
  name: 'Couponcode',

  data () {
    return {
      response: '',
      commentRespone: '',
      comment: ''
    }
  },

  methods: {
    vote: function (value) {
      axios.post(endpoints.survey, {
        value: value
      })
        .then(response => {
          this.response = response.data
        })
    },

    sendcomment: function () {
      axios.post(endpoints.surveyComment, {
        id: this.response,
        comment: this.comment
      })
        .then(response => {
          this.commentRespone = response.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Feedback.vue